// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DocumentTemplate.yaml
// Generated: 2026-07-07T12:10:40.884Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDocumentTemplate, UpdateDocumentTemplate, DocumentTemplate } from '@/types/core/DocumentTemplate';

/**
 * DocumentTemplate Service
 * CRUD operations for DocumentTemplate via the ABP API.
 */
export const documentTemplateService = new EntityService<DocumentTemplate, CreateDocumentTemplate, UpdateDocumentTemplate>(
  '/api/core/documenttemplate',
  'DocumentTemplate',
);
